import { render } from "./grid-icon.svg?vue&type=template&id=6e2e1b8c"
import script from "./grid-icon.svg?vue&type=script&lang=js"
export * from "./grid-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2836/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__